<template>
	<div class="shape-list">
    <template
        v-for="(shape, $shapeIndex) in NODE_SHAPES"
        :key="$shapeIndex"
    >
      <div
          v-if="!shape.disabled"
          :class="{
				active: shape.VALUE === shapeCurrent,
				 'tooltip tooltip--centered dark opacity--05': shape.disabled}"
          @click="chooseShape(shape)"
          class="shape-item"
          :aria-label="shape.VALUE"
      >
        <i :class="shape.ICON"></i>
        <div
            v-if="shape.disabled"
            class="tooltip__item bottom"
        >{{ t('common.soon') }}</div>
      </div>
    </template>
	</div>
</template>

<script>
import {NODE_SHAPES} from '@/models/NODE_SHAPES';
import {useI18n} from 'vue-i18n';

export default {
	props: {
		shapeCurrent: {
			type: String,
			default: NODE_SHAPES.CIRCLE.VALUE
		}
	},
	setup(props, {emit}) {
		const {t} = useI18n();
		function chooseShape(shape){
			if(shape.disabled) return;
			emit('update:shapeCurrent', NODE_SHAPES[shape.VALUE.toUpperCase()].VALUE)
		}
		
		return {
			t,
			NODE_SHAPES,
			chooseShape
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/elements/shapes/shape-icons";
@use "@/scss/sections/editor/elements/shapes/shape-list";
@use "@/scss/sections/editor/elements/shapes/shape-item";
</style>
